import { render, staticRenderFns } from "./GisogdDocGroups.vue?vue&type=template&id=1d604941&"
import script from "./GisogdDocGroups.vue?vue&type=script&lang=js&"
export * from "./GisogdDocGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports